var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAfternoon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327,264c7.19,0,128.17.8,135.78.56.54,0,.84-.82.29-1.09-4.79-2.38-10.23-1.9-15.21-3.58-2.93-1-4.73-2.9-6.76-5.1a14,14,0,0,0-6.3-4.11,13.26,13.26,0,0,0-6.85-.21c-2.46.58-4.59,2-6.93,2.87-5.81,2.2-11.46.11-15.61-4.19-3.42-3.54-6.79-6.89-11.44-8.8a15.16,15.16,0,0,0-12.12-.16c-4.44,2-7.48,6.05-11.65,8.48-4.94,2.89-10.85,2.21-16.31,3.08s-9.64,5.47-14.43,8.11a10.24,10.24,0,0,1-5.22,1.62c-1.07,0-2.12-.32-3.17-.45-1.65-.2-3.22-.16-4.33,1.22C326.51,262.58,326.56,264,327,264Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.91,104.68c5.25,0,93.58.58,99.13.41.4,0,.62-.6.22-.8-3.5-1.73-7.47-1.38-11.11-2.61C123,101,121.7,99.56,120.22,98a10.25,10.25,0,0,0-4.6-3,9.64,9.64,0,0,0-5-.16c-1.8.43-3.35,1.45-5.06,2.1-4.25,1.6-8.37.08-11.4-3.06-2.5-2.59-5-5-8.35-6.42A11.12,11.12,0,0,0,77,87.29c-3.24,1.47-5.46,4.42-8.51,6.2-3.6,2.11-7.92,1.61-11.9,2.25s-7,4-10.54,5.92a7.52,7.52,0,0,1-3.81,1.18,22.72,22.72,0,0,1-2.32-.33,3.17,3.17,0,0,0-3.15.89C36.53,103.65,36.57,104.68,36.91,104.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.11,199.88c5.25,0,93.57.58,99.13.41.39,0,.61-.6.21-.8-3.5-1.73-7.47-1.38-11.1-2.61-2.14-.72-3.46-2.12-4.94-3.72a10.2,10.2,0,0,0-4.6-3,9.64,9.64,0,0,0-5-.16,42.82,42.82,0,0,0-5.06,2.1c-4.24,1.6-8.37.08-11.4-3.06-2.49-2.59-5-5-8.35-6.42a11.08,11.08,0,0,0-8.85-.13c-3.24,1.47-5.46,4.42-8.5,6.2-3.61,2.11-7.92,1.61-11.91,2.24s-7,4-10.54,5.93a7.49,7.49,0,0,1-3.81,1.18,23.13,23.13,0,0,1-2.32-.33,3.17,3.17,0,0,0-3.15.89C324.72,198.84,324.76,199.88,325.11,199.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.57,209.23c5.25,0,93.58.58,99.13.4.4,0,.61-.6.22-.79-3.5-1.74-7.47-1.39-11.11-2.61-2.14-.72-3.45-2.12-4.94-3.73a10.22,10.22,0,0,0-4.59-3,9.79,9.79,0,0,0-5-.16c-1.79.43-3.35,1.46-5.06,2.1-4.24,1.61-8.36.08-11.39-3.06-2.5-2.58-5-5-8.35-6.42a11.08,11.08,0,0,0-8.85-.12c-3.24,1.47-5.47,4.42-8.51,6.19-3.61,2.11-7.92,1.61-11.9,2.25s-7,4-10.54,5.92a7.45,7.45,0,0,1-3.81,1.18c-.78,0-1.55-.23-2.32-.32a3.18,3.18,0,0,0-3.16.88C102.19,208.19,102.23,209.23,102.57,209.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.41,170.85c.1.29,139.21,0,137.46,0-.8,0,1.21-1.2.43-1.59-4.53-2.25-9.49-2.31-14.42-2.76a22.26,22.26,0,0,1-8.42-2c-2.62-1.38-4.25-3.76-6.12-6a26.1,26.1,0,0,0-23.75-9c-9.89,1.55-17.69,9.08-27.6,10.47-6,.83-11.58-1.47-17.4-2.28a21.24,21.24,0,0,0-13.06,2.38c-3.14,1.56-6,2.87-9.59,3.11-2.72.2-5.46-.11-8.18-.14a18.34,18.34,0,0,0-12,4.81C144.26,168.24,142.86,170.85,147.41,170.85Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.66,424.37c-.78-.32-1.12.95-.35,1.26a4.25,4.25,0,0,1,2.47,5.13.65.65,0,0,0,1.26.35A5.59,5.59,0,0,0,442.66,424.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.38,423.15a10,10,0,0,0-.76,5.78c.13.83,1.39.48,1.26-.35a8.5,8.5,0,0,1,.62-4.77C449.84,423.05,448.72,422.39,448.38,423.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.69,341.18c-.78-.32-1.12.95-.35,1.26a4.25,4.25,0,0,1,2.47,5.13.65.65,0,0,0,1.26.35A5.59,5.59,0,0,0,413.69,341.18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.41,340a10,10,0,0,0-.76,5.78c.13.83,1.39.48,1.26-.35a8.5,8.5,0,0,1,.62-4.77C420.87,339.86,419.75,339.2,419.41,340Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.46,451.78c-.74-.39-1.4.73-.66,1.13a4,4,0,0,1,2.16,3.95c-.07.84,1.24.84,1.31,0A5.28,5.28,0,0,0,308.46,451.78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2,358.17c-.75-.4-1.41.73-.66,1.13a4,4,0,0,1,2.16,3.95c-.07.84,1.24.84,1.3,0A5.29,5.29,0,0,0,54.2,358.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.31,444.82c-.4-.74-1.53-.08-1.13.66a10.55,10.55,0,0,1,1.23,5.59c0,.84,1.26.83,1.31,0A11.83,11.83,0,0,0,226.31,444.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.34,445.69a6.81,6.81,0,0,0-.84,4.17c.11.82,1.41.83,1.31,0a5.71,5.71,0,0,1,.65-3.51C230.87,445.61,229.74,445,229.34,445.69Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.57,329.31c-.4-.74-1.53-.08-1.13.66a10.36,10.36,0,0,1,1.23,5.59c0,.84,1.27.84,1.31,0A11.73,11.73,0,0,0,94.57,329.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6,330.18a6.81,6.81,0,0,0-.83,4.17c.1.82,1.41.83,1.3,0a5.65,5.65,0,0,1,.66-3.51C99.13,330.1,98,329.44,97.6,330.18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.39,420.25c-.74-.4-1.41.73-.66,1.13a4,4,0,0,1,2.16,3.95c-.07.84,1.24.83,1.31,0A5.28,5.28,0,0,0,137.39,420.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.28,418.2c-.4-.74-1.53-.08-1.13.66a10.36,10.36,0,0,1,1.23,5.59c0,.84,1.27.84,1.31,0A11.73,11.73,0,0,0,141.28,418.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.31,419.07a6.82,6.82,0,0,0-.83,4.17c.1.83,1.41.84,1.3,0a5.65,5.65,0,0,1,.66-3.51C145.84,419,144.72,418.33,144.31,419.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.67,456.67a.65.65,0,0,0-.66,1.13,5.29,5.29,0,0,1,2.63,4.92c0,.84,1.26.84,1.31,0A6.61,6.61,0,0,0,168.67,456.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.46,459.8l-.45,2.63c-.14.82,1.12,1.17,1.26.34l.45-2.63C174.86,459.32,173.6,459,173.46,459.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.58,426.15c-.65-.53-1.57.39-.93.92a6.07,6.07,0,0,1,2.26,5.12c0,.84,1.27.84,1.31,0A7.3,7.3,0,0,0,51.58,426.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.32,410.43c.64-.53,1.57.39.93.93a6,6,0,0,0-2.26,5.11c0,.84-1.27.84-1.31,0A7.3,7.3,0,0,1,377.32,410.43Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.22,357.26c.64-.53,1.57.39.92.93a6.07,6.07,0,0,0-2.26,5.11c.05.84-1.26.84-1.3,0A7.28,7.28,0,0,1,452.22,357.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.27,450.11a7.76,7.76,0,0,0-2.08,6.91c.15.82,1.41.47,1.26-.35a6.36,6.36,0,0,1,1.74-5.64C353.78,450.43,352.85,449.5,352.27,450.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.5,450.82v4.39a.66.66,0,0,0,1.31,0v-4.39A.66.66,0,0,0,347.5,450.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.5,452.2a4,4,0,0,0-1.85,3.55c0,.84,1.34.85,1.31,0a2.67,2.67,0,0,1,1.2-2.42C355.86,452.87,355.2,451.74,354.5,452.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.91,315.62s75.57-51.89,122.43-51.89c56.28,0,111,23.12,131.7,30.76,54.49,20.06,160,21.13,160,21.13Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.09,315.62s-42.91-30.19-91.38-30.19c-33.84,0-82.4,6.25-128.13,16.5-17.42,3.9-108.07,13.69-108.07,13.69Z",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sun--inject-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 374.49,
    cy: 92.42,
    r: 47.21,
    style: {
      fill: "#FFC727",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.49,
    cy: 92.42,
    r: 36.09,
    style: {
      fill: "#FFC727"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Blanket--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "462.71 382.05 244.98 442.5 27.25 382.05 244.98 343.14 462.71 382.05",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462.71 382.05 244.98 442.5 27.25 382.05 244.98 343.14 462.71 382.05",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.87 386.39 45.36 387.08 45.36 386.39 45.36 378.82 35.32 380.61 35.32 384.3 42.87 386.39",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.84 375.16 65.84 392.77 55.8 389.98 55.8 376.95 61.43 375.94 65.84 375.16",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.32 371.5 86.32 398.46 79.01 396.42 76.28 395.67 76.28 373.29 86.32 371.5",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.8 367.84 106.8 404.14 96.75 401.35 96.75 369.63 106.8 367.84",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.28 364.17 127.28 409.83 117.23 407.03 117.23 365.91 117.58 365.91 127.28 364.17",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.74 360.52 147.74 415.5 137.71 412.72 137.71 362.31 147.74 360.52",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.22 356.86 168.22 421.19 158.19 418.41 158.19 358.65 168.22 356.86",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.7 353.2 188.7 426.88 178.67 424.09 178.67 354.99 188.7 353.2",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.18 349.54 209.18 432.56 199.15 429.78 199.15 351.33 209.18 349.54",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.66 345.88 229.66 438.25 226.54 437.38 219.62 435.47 219.62 347.67 229.66 345.88",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.14 344.06 250.14 441.07 244.98 442.5 240.09 441.15 240.09 344.01 244.98 343.14 250.14 344.06",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.61 347.72 270.61 435.38 263.43 437.38 260.57 438.18 260.57 345.92 270.61 347.72",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.09 351.38 291.09 429.71 281.05 432.5 281.05 349.59 291.09 351.38",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.57 355.04 311.57 424.02 301.53 426.81 301.53 353.24 311.57 355.04",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.05 358.69 332.05 418.34 322 421.12 322 356.91 332.05 358.69",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.53 362.36 352.53 412.65 342.48 415.43 342.48 360.56 352.53 362.36",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373 365.91 373 406.96 362.96 409.75 362.96 364.23 372.38 365.91 373 365.91",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.48 369.68 393.48 401.28 383.44 404.06 383.44 367.88 393.48 369.68",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.95 373.33 413.95 395.59 410.96 396.42 403.92 398.37 403.92 371.55 413.95 373.33",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.43 377 434.43 389.9 424.4 392.69 424.4 375.2 428.54 375.94 434.43 377",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "454.91 380.65 454.91 384.21 447.1 386.39 444.87 387.01 444.87 378.87 454.91 380.65",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.94 355.46 176.02 355.46 178.67 354.99 188.7 353.2 199.15 351.33 209.18 349.54 219.62 347.67 229.66 345.88 232.16 345.43 257.8 345.43 260.57 345.92 270.61 347.72 281.05 349.59 291.09 351.38 301.53 353.24 311.57 355.04 313.94 355.46",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.8 367.84 96.75 369.63 86.32 371.5 76.28 373.29 65.84 375.16 61.43 375.94 65.84 375.94 76.28 375.94 86.32 375.94 96.75 375.94 106.8 375.94 117.23 375.94 127.28 375.94 137.71 375.94 147.74 375.94 158.19 375.94 168.22 375.94 178.67 375.94 188.7 375.94 199.15 375.94 209.18 375.94 219.62 375.94 229.66 375.94 240.09 375.94 250.14 375.94 260.57 375.94 270.61 375.94 281.05 375.94 291.09 375.94 301.53 375.94 311.57 375.94 322 375.94 332.05 375.94 342.48 375.94 352.53 375.94 362.96 375.94 373 375.94 383.44 375.94 393.48 375.94 403.92 375.94 413.95 375.94 424.4 375.94 428.54 375.94 424.4 375.2 413.95 373.33 403.92 371.55 393.48 369.68 383.44 367.88 373 366.01 373 365.91 372.38 365.91 362.96 365.91 352.53 365.91 342.48 365.91 332.05 365.91 322 365.91 311.57 365.91 301.53 365.91 291.09 365.91 281.05 365.91 270.61 365.91 260.57 365.91 250.14 365.91 240.09 365.91 229.66 365.91 219.62 365.91 209.18 365.91 199.15 365.91 188.7 365.91 178.67 365.91 168.22 365.91 158.19 365.91 147.74 365.91 137.71 365.91 127.28 365.91 117.58 365.91 117.23 365.91 106.8 367.84",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.1 386.39 444.87 387.01 434.43 389.9 424.4 392.69 413.95 395.59 410.96 396.42 79.01 396.42 76.28 395.67 65.84 392.77 55.8 389.98 45.36 387.08 42.87 386.39 447.1 386.39",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.38 406.86 373 406.96 362.96 409.75 352.53 412.65 342.48 415.43 337.19 416.9 152.77 416.9 147.74 415.5 137.71 412.72 127.28 409.83 117.23 407.03 116.58 406.86 373.38 406.86",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.62 427.34 291.09 429.71 281.05 432.5 270.61 435.38 263.43 437.38 226.54 437.38 219.62 435.47 209.18 432.56 199.15 429.78 190.35 427.34 299.62 427.34",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trees--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.6,303c-.92.93-11.72,1.34-15.65,1.34S159.22,304,158.3,303s12.15-72.7,15.65-72.7S190.53,302.12,189.6,303Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.82,284.75c-2.67,1-12.55,5-14.69,6.22v-1.35q3.57-2.1,7.17-4.18a86.53,86.53,0,0,0,7.71-4.59c.12-.09.05-.33-.11-.26a64.54,64.54,0,0,0-7.55,4.17c-2.43,1.43-4.83,2.89-7.22,4.37,0-3.44,0-6.88,0-10.31a82.27,82.27,0,0,0,11.27-5.73c.12-.07,0-.3-.11-.24a83.1,83.1,0,0,0-11.16,5.5c0-1.79,0-3.57,0-5.36-.1-9.21-.12-18.43-.35-27.64,2.34-1.19,4.76-2.23,7.1-3.42.15-.08,0-.34-.12-.28-2.38.93-4.67,2-7,3-.13-4.75-.31-9.5-.6-14.24a.12.12,0,1,0-.24,0c-.33,8.82-.3,17.65-.19,26.48-2.43-1.94-5-3.65-7.49-5.53-.09-.07-.19.09-.09.16,2.58,2,5,4.14,7.59,6.1,0,.5,0,1,0,1.5-2.64-1.2-5.31-2.32-8-3.46-.21-.09-.39.21-.18.31,2.71,1.3,5.41,2.62,8.16,3.85q.09,6.56.19,13.12c.1,7.63.27,15.27.43,22.91q-7.45-3.78-15-7.34c-.19-.09-.36.18-.17.29a157.49,157.49,0,0,0,15.2,7.63c.14,6.35.27,12.69.35,19a.3.3,0,0,0,.6,0c-.09-8.09-.1-16.19-.13-24.28,2.63-.65,12.52-4.89,14.88-6.05C190.25,285.07,190.08,284.65,189.82,284.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.16,303c-.92.93-11.72,1.34-15.65,1.34S340.79,304,339.86,303s12.15-72.7,15.65-72.7S372.09,302.12,371.16,303Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.38,284.75c-2.67,1-12.55,5-14.68,6.22,0-.45,0-.9,0-1.35,2.38-1.4,4.78-2.79,7.17-4.18a86.53,86.53,0,0,0,7.71-4.59c.12-.09.05-.33-.11-.26a64.41,64.41,0,0,0-7.54,4.17q-3.65,2.14-7.23,4.37c0-3.44,0-6.88-.05-10.31a81.7,81.7,0,0,0,11.27-5.73c.12-.07,0-.3-.1-.24a82.63,82.63,0,0,0-11.17,5.5c0-1.79,0-3.57,0-5.36-.1-9.21-.11-18.43-.35-27.64,2.34-1.19,4.76-2.23,7.1-3.42.15-.08,0-.34-.12-.28-2.38.93-4.66,2-7,3q-.18-7.12-.59-14.24a.13.13,0,0,0-.25,0c-.33,8.82-.3,17.65-.19,26.48-2.43-1.94-5-3.65-7.49-5.53-.09-.07-.19.09-.09.16,2.58,2,5,4.14,7.59,6.1,0,.5,0,1,0,1.5-2.64-1.2-5.31-2.32-8-3.46-.2-.09-.39.21-.18.31,2.71,1.3,5.41,2.62,8.16,3.85q.09,6.56.19,13.12c.1,7.63.27,15.27.43,22.91q-7.46-3.78-15-7.34a.17.17,0,0,0-.16.29,156.18,156.18,0,0,0,15.19,7.63c.14,6.35.27,12.69.35,19a.3.3,0,0,0,.6,0c-.09-8.09-.1-16.19-.12-24.28,2.62-.65,12.52-4.89,14.87-6.05C371.81,285.07,371.64,284.65,371.38,284.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.15,304.85c-.8.8-10.06,1.15-13.43,1.15s-12.64-.35-13.44-1.15,10.43-62.39,13.44-62.39S72,304.06,71.15,304.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.34,289.16c-2.29.87-10.78,4.32-12.61,5.33v-1.16l6.15-3.59a72.06,72.06,0,0,0,6.62-3.93c.1-.07,0-.28-.09-.22a53.8,53.8,0,0,0-6.48,3.58c-2.09,1.22-4.15,2.48-6.2,3.75,0-2.95,0-5.91,0-8.86a69.68,69.68,0,0,0,9.67-4.91c.1-.06,0-.26-.09-.21a69.26,69.26,0,0,0-9.58,4.73c0-1.54,0-3.07,0-4.61-.08-7.9-.1-15.81-.3-23.72,2-1,4.08-1.91,6.09-2.93.14-.07,0-.3-.1-.24-2,.79-4,1.74-6,2.62-.11-4.08-.27-8.16-.52-12.23a.11.11,0,0,0-.21,0c-.28,7.57-.26,15.15-.16,22.73-2.08-1.66-4.31-3.13-6.43-4.75-.08-.06-.16.08-.08.14,2.22,1.69,4.29,3.56,6.52,5.24,0,.43,0,.85,0,1.28-2.26-1-4.55-2-6.83-3-.18-.08-.34.18-.16.27,2.33,1.11,4.65,2.25,7,3.3q.09,5.64.17,11.26c.08,6.55.23,13.11.37,19.66q-6.41-3.24-12.89-6.29c-.16-.08-.31.15-.14.24a133.55,133.55,0,0,0,13,6.56c.11,5.44.23,10.88.3,16.33a.26.26,0,0,0,.51,0c-.08-6.94-.09-13.89-.11-20.83a130.69,130.69,0,0,0,12.77-5.19C71.7,289.43,71.56,289.07,71.34,289.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.44,306.58c.67.67,8.47,1,11.31,1s10.64-.3,11.31-1S340.28,254,337.75,254,325.77,305.91,326.44,306.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.28,293.36c1.93.74,9.07,3.65,10.61,4.5,0-.33,0-.65,0-1l-5.18-3a61.12,61.12,0,0,1-5.58-3.31c-.08-.07,0-.24.08-.19a46,46,0,0,1,5.46,3c1.75,1,3.49,2.09,5.22,3.16,0-2.48,0-5,0-7.46a58.67,58.67,0,0,1-8.14-4.13c-.09-.06,0-.22.07-.18a59.83,59.83,0,0,1,8.07,4l0-3.88c.07-6.65.09-13.32.26-20-1.7-.86-3.44-1.61-5.14-2.47-.11-.06,0-.25.09-.2,1.72.67,3.37,1.46,5.06,2.2.09-3.43.22-6.86.43-10.29a.09.09,0,0,1,.18,0c.23,6.37.22,12.75.14,19.14,1.75-1.4,3.62-2.64,5.41-4,.06,0,.13.06.06.11-1.86,1.42-3.61,3-5.48,4.42,0,.36,0,.72,0,1.08,1.91-.87,3.84-1.68,5.76-2.51.15-.06.28.16.13.23-2,.94-3.91,1.9-5.89,2.78q-.07,4.74-.14,9.48c-.07,5.52-.2,11-.31,16.56q5.38-2.73,10.85-5.3a.12.12,0,0,1,.12.21,112.57,112.57,0,0,1-11,5.51q-.15,6.89-.25,13.76a.22.22,0,0,1-.44,0c.07-5.85.08-11.7.09-17.55a105.88,105.88,0,0,1-10.74-4.37C326,293.6,326.09,293.29,326.28,293.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.66,306.58c.67.67,8.48,1,11.32,1s10.64-.3,11.31-1S81.51,254,79,254,67,305.91,67.66,306.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.51,293.36c1.93.74,9.07,3.65,10.61,4.5,0-.33,0-.65,0-1l-5.18-3a61.12,61.12,0,0,1-5.58-3.31c-.08-.07,0-.24.08-.19a45.15,45.15,0,0,1,5.45,3c1.76,1,3.5,2.09,5.23,3.16q0-3.72,0-7.46A58.12,58.12,0,0,1,70,284.94c-.09-.06,0-.22.07-.18a59.83,59.83,0,0,1,8.07,4c0-1.29,0-2.58,0-3.88.07-6.65.08-13.32.25-20-1.69-.86-3.44-1.61-5.13-2.47-.11-.06,0-.25.09-.2,1.72.67,3.37,1.46,5.06,2.2.09-3.43.22-6.86.43-10.29a.09.09,0,1,1,.17,0c.24,6.37.22,12.75.14,19.14,1.76-1.4,3.63-2.64,5.41-4,.07,0,.14.06.07.11-1.87,1.42-3.61,3-5.48,4.42,0,.36,0,.72,0,1.08,1.9-.87,3.83-1.68,5.76-2.51.15-.06.28.16.13.23-2,.94-3.91,1.9-5.9,2.78q-.06,4.74-.14,9.48c-.07,5.52-.19,11-.31,16.56,3.59-1.82,7.22-3.59,10.86-5.3a.12.12,0,0,1,.12.21,112.57,112.57,0,0,1-11,5.51c-.1,4.59-.2,9.17-.26,13.76a.22.22,0,0,1-.43,0c.06-5.85.07-11.7.09-17.55a106,106,0,0,1-10.75-4.37C67.2,293.6,67.32,293.29,67.51,293.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.76,304c-.86.85-10.82,1.23-14.45,1.23s-13.59-.38-14.44-1.23,11.21-67.1,14.44-67.1S247.61,303.17,246.76,304Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,287.15c-2.46.94-11.58,4.65-13.55,5.73,0-.41,0-.83,0-1.24,2.2-1.3,4.41-2.58,6.62-3.86a80.85,80.85,0,0,0,7.12-4.23c.1-.08,0-.3-.11-.24a59.06,59.06,0,0,0-7,3.85c-2.24,1.31-4.46,2.67-6.67,4,0-3.17,0-6.35,0-9.52a76.8,76.8,0,0,0,10.39-5.28c.12-.07,0-.28-.09-.23a76.9,76.9,0,0,0-10.3,5.08c0-1.65,0-3.3,0-4.95-.09-8.5-.11-17-.32-25.51,2.16-1.09,4.39-2.05,6.55-3.15.14-.07,0-.32-.11-.26-2.19.86-4.31,1.87-6.46,2.82-.12-4.39-.28-8.77-.55-13.15a.12.12,0,0,0-.23,0c-.3,8.14-.28,16.29-.17,24.44-2.24-1.79-4.63-3.37-6.91-5.1-.09-.07-.18.08-.09.15,2.38,1.81,4.61,3.82,7,5.63,0,.46,0,.92,0,1.38-2.43-1.11-4.89-2.14-7.35-3.2-.19-.08-.36.2-.17.29,2.51,1.2,5,2.42,7.53,3.55.06,4,.13,8.08.18,12.11.09,7,.25,14.1.4,21.14q-6.88-3.48-13.86-6.77c-.18-.08-.33.17-.16.27a147.12,147.12,0,0,0,14,7.05c.12,5.85.24,11.71.32,17.56a.28.28,0,0,0,.55,0c-.08-7.47-.09-14.94-.11-22.4,2.42-.6,11.55-4.51,13.72-5.58C247.35,287.44,247.2,287.06,247,287.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.28,304c-.86.85-10.82,1.23-14.45,1.23s-13.59-.38-14.44-1.23,11.21-67.1,14.44-67.1S456.13,303.17,455.28,304Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.48,287.15c-2.47.94-11.59,4.65-13.56,5.73v-1.24c2.2-1.3,4.41-2.58,6.61-3.86a79.42,79.42,0,0,0,7.12-4.23c.11-.08.05-.3-.1-.24a59.06,59.06,0,0,0-7,3.85c-2.25,1.31-4.46,2.67-6.67,4,0-3.17,0-6.35,0-9.52a76.8,76.8,0,0,0,10.39-5.28c.11-.07,0-.28-.09-.23a77,77,0,0,0-10.31,5.08c0-1.65,0-3.3,0-4.95-.09-8.5-.11-17-.33-25.51,2.17-1.09,4.39-2.05,6.56-3.15.14-.07,0-.32-.11-.26-2.2.86-4.31,1.87-6.46,2.82-.12-4.39-.29-8.77-.56-13.15a.11.11,0,0,0-.22,0c-.3,8.14-.28,16.29-.18,24.44-2.24-1.79-4.63-3.37-6.91-5.1-.08-.07-.17.08-.08.15,2.38,1.81,4.61,3.82,7,5.63,0,.46,0,.92,0,1.38-2.43-1.11-4.9-2.14-7.35-3.2-.19-.08-.36.2-.17.29,2.5,1.2,5,2.42,7.53,3.55l.18,12.11c.09,7,.24,14.1.39,21.14-4.58-2.32-9.21-4.58-13.85-6.77-.18-.08-.34.17-.16.27a145.94,145.94,0,0,0,14,7.05c.12,5.85.24,11.71.32,17.56a.28.28,0,0,0,.55,0c-.08-7.47-.1-14.94-.12-22.4,2.42-.6,11.56-4.51,13.73-5.58C455.87,287.44,455.71,287.06,455.48,287.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.22,307.57c.6.6,7.57.87,10.1.87s9.5-.27,10.1-.87-7.84-46.89-10.1-46.89S199.63,307,200.22,307.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.08,295.78c1.73.65,8.1,3.25,9.48,4v-.87c-1.54-.91-3.08-1.8-4.62-2.7a53.08,53.08,0,0,1-5-3c-.07-.05,0-.21.07-.17a42,42,0,0,1,4.87,2.69c1.57.92,3.12,1.87,4.66,2.82l0-6.65a53.92,53.92,0,0,1-7.27-3.69c-.07-.05,0-.2.07-.16a53.43,53.43,0,0,1,7.2,3.55c0-1.15,0-2.31,0-3.46.06-5.94.07-11.89.22-17.83-1.51-.76-3.07-1.43-4.58-2.2-.09-.05,0-.22.08-.18,1.53.6,3,1.31,4.51,2,.09-3.07.2-6.13.39-9.19a.08.08,0,0,1,.16,0c.21,5.69.19,11.38.12,17.08,1.57-1.25,3.24-2.36,4.83-3.57.06,0,.12.06.06.11-1.67,1.26-3.22,2.67-4.89,3.93,0,.32,0,.65,0,1,1.7-.78,3.42-1.5,5.14-2.24.13-.05.25.14.12.2-1.75.84-3.49,1.7-5.26,2.49,0,2.82-.09,5.64-.13,8.46-.06,4.93-.17,9.85-.28,14.77q4.82-2.43,9.69-4.73c.12-.05.23.12.11.19a100.78,100.78,0,0,1-9.8,4.92c-.09,4.1-.18,8.19-.23,12.28a.19.19,0,0,1-.38,0c.05-5.22.06-10.44.08-15.66a94.51,94.51,0,0,1-9.6-3.9C199.81,296,199.92,295.71,200.08,295.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.16,307.57c.6.6,7.56.87,10.09.87s9.5-.27,10.1-.87-7.84-46.89-10.1-46.89S398.56,307,399.16,307.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399,295.78c1.72.65,8.09,3.25,9.47,4v-.87c-1.53-.91-3.08-1.8-4.62-2.7a52.92,52.92,0,0,1-5-3c-.08-.05,0-.21.07-.17a41.09,41.09,0,0,1,4.86,2.69c1.57.92,3.12,1.87,4.67,2.82q0-3.32,0-6.65a53.8,53.8,0,0,1-7.26-3.69c-.08-.05,0-.2.06-.16a53,53,0,0,1,7.21,3.55c0-1.15,0-2.31,0-3.46.06-5.94.08-11.89.23-17.83-1.52-.76-3.07-1.43-4.58-2.2-.1-.05,0-.22.07-.18,1.54.6,3,1.31,4.52,2,.08-3.07.2-6.13.38-9.19,0-.1.16-.1.16,0,.21,5.69.2,11.38.13,17.08,1.56-1.25,3.23-2.36,4.82-3.57a.06.06,0,0,1,.06.11c-1.66,1.26-3.22,2.67-4.89,3.93,0,.32,0,.65,0,1,1.69-.78,3.42-1.5,5.13-2.24.14-.05.26.14.12.2-1.75.84-3.49,1.7-5.26,2.49,0,2.82-.09,5.64-.12,8.46-.07,4.93-.18,9.85-.28,14.77q4.8-2.43,9.68-4.73c.13-.05.23.12.11.19a99.66,99.66,0,0,1-9.8,4.92q-.13,6.15-.22,12.28a.2.2,0,0,1-.39,0c.06-5.22.07-10.44.08-15.66a93.41,93.41,0,0,1-9.59-3.9C398.74,296,398.85,295.71,399,295.78Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "37.28 315.7 90.46 315.46 143.64 315.37 250 315.2 356.36 315.37 409.54 315.46 462.71 315.7 409.54 315.95 356.36 316.04 250 316.2 143.64 316.03 90.46 315.95 37.28 315.7",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.42,384.05c-2.84,1.09-85.44,2.59-88.68.75-.35-.21-.25-3.86-1.47-13.29-.06-.45-1.94-2.2-4.88-4.66-11.05-9.26-37-28.78-37-28.78l41.22-35.82,39.95,39.27,10.39,10.21S434.69,370,438,372.36,444.27,383,441.42,384.05Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.42,384.05c-2.84,1.1-85.45,2.59-88.68.75-.35-.21-.25-3.85-1.47-13.29,0-.45-1.94-2.19-4.89-4.67-3.84-3.22-5.66-4.69-11.38-9.14l52.41-19.27,3.14,3.09,10.39,10.21S434.69,370,438,372.36,444.27,383,441.42,384.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.12,385.19c-2.87,1-90.89,2-94.05,0-.75-.46-1.43-5.57-2-12.57-.07-.88-9-8-10.2-9.33l53.93-18.16,6.81,6.41s39.69,18.46,42.94,21S450,384.19,447.12,385.19Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.89,381.9c-13.82-.17-75.16.41-88.84,1.29-.11,0-.11.08,0,.08,13.7.48,75-.56,88.85-1.14C446.19,382.12,446.19,381.91,445.89,381.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,352.13c-5.45-.95-12.09,0-16.21,3.88-.15.16.06.38.24.32a76.35,76.35,0,0,1,16-3.51A.35.35,0,0,0,406,352.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,354.45c-5.45-.95-12.09,0-16.2,3.88-.16.16.06.38.23.32a76.35,76.35,0,0,1,16-3.51A.35.35,0,0,0,410,354.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.94,356.77c-5.45-.95-12.1,0-16.21,3.88-.16.16.06.38.24.32a76.07,76.07,0,0,1,16-3.51A.35.35,0,0,0,413.94,356.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.89,359.09c-5.45-.95-12.09,0-16.2,3.88-.16.16.06.38.23.32a76.35,76.35,0,0,1,16-3.51A.35.35,0,0,0,417.89,359.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.93,339.43c-2.17-2.92-6.14-1.55-8.38.39a29,29,0,0,0-8.24,12.56.14.14,0,0,0,.13.19c0,.41.4.85.86.67,4.48-1.72,9.47-3,13.28-6C415.81,345.43,418,342.19,415.93,339.43Zm-9.38,9.82c-2.18.9-4.39,1.68-6.53,2.66a86.55,86.55,0,0,1,5-7.23,31.42,31.42,0,0,1,2.84-3.15c1.6-1.49,8-4.7,7.09,1.28C414.43,346.11,409.15,348.18,406.55,349.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.47,351.12c4.51,1.86,9.66,1.7,14.43,2.1a.66.66,0,0,0,.64-.88.14.14,0,0,0,.07-.22,28.92,28.92,0,0,0-11.39-9.78c-2.7-1.23-6.89-1.45-8.16,2C379.85,347.52,382.84,350,385.47,351.12Zm-2.5-3.85c-2.52-5.5,4.5-4.19,6.45-3.2a32.84,32.84,0,0,1,3.61,2.24,86,86,0,0,1,6.78,5.56c-2.33-.34-4.67-.48-7-.74C390,350.82,384.36,350.3,383,347.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.12,339.33l-51,26.4s-53.08-48.05-57.94-48.4S205.94,365.43,170,365.58c-37.23.15-39.12-38.86-39.12-38.86l54.32-12.48c39.16-19.3,79.95-54,106.62-50.72C320.78,267,391.12,339.33,391.12,339.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.67,332.6c-8.6,4.26-6.19,2.92-14.74,7.26-4.19,2.13-25.26,12.76-28.84,15.39-.08.06,0,.2.09.17,4.21-1.41,25.05-12.5,29.19-14.7,8.48-4.5,6-3.29,14.42-7.88A.13.13,0,1,0,378.67,332.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.14,353.56c-10-8.79-42.6-37.38-43.93-38.44a17.57,17.57,0,0,0-3.4-2.55,3.59,3.59,0,0,0-3.14.25c-1.51.71-3,1.48-4.48,2.21l-8.83,4.31c-11.42,5.57-22.77,11.29-34.28,16.68-11.06,5.18-19,10.06-30.51,14a172.89,172.89,0,0,1-35.44,8.45c-1.49.18-3,.34-4.48.48-.11,0-.11.18,0,.17a142.49,142.49,0,0,0,34.89-6.49c11.45-3.52,19.21-8.09,30.08-13.09,11.27-5.18,22.38-10.73,33.48-16.25,5.86-2.91,11.72-5.85,17.59-8.73,1.34-.66,3.24-2.07,4.76-1.37a8.57,8.57,0,0,1,1.76,1.29l2,1.63c2.52,2.1,42.53,36.56,43.84,37.55C331.1,353.78,331.24,353.64,331.14,353.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.76,326.72s-6.1,35.23,11.52,49.07S289,388,308.53,381.63s20.2-37.93-1.21-45.25c-20.36-7-107-10.35-109.12-11.2-.53-.21,7.68-5.14,7.65-5.44l-19.71-6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.5,325.83c0-.15-.26-.1-.26,0a17.41,17.41,0,0,1-4.08,11.19c-3,3.46-7.42,5.4-11.42,7.43-.39.19-.1.8.3.68a35.77,35.77,0,0,0,7.08-3.05,17.11,17.11,0,0,0,5.32-4.43A15.23,15.23,0,0,0,157.5,325.83Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.78,321.46c-.89-1.14-1.86-2.22-2.8-3.33-2.2-2.63-4.42-5.27-6.73-7.8-.22-.24-.65.1-.45.36,1.56,2,3.21,4,4.83,6,.83,1,1.66,2,2.5,3a18.91,18.91,0,0,1,2.34,3c.61,1.13-.19,2.1-1.36,2.22a4.07,4.07,0,0,1-2.82-1,37.18,37.18,0,0,1-4.77-5.1c-.93-1-1.86-2.09-2.8-3.12s-2.08-2.14-3.08-3.24c-.06-.07-.19,0-.13.11.88,1.19,1.68,2.45,2.56,3.65s1.76,2.39,2.67,3.57,1.74,2.21,2.65,3.28a10.81,10.81,0,0,0,2.69,2.4c1.67,1,4.58,1.2,5.47-1A3.06,3.06,0,0,0,196.78,321.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.85,381.75c-6.74.12-13.48.52-20.22.66s-13.38.18-20.07.12q-20.15-.19-40.27-1.57c-13.54-.94-28.15-2.28-41.6-4.15-6.44-.89-13-1.63-19.33-3A30.53,30.53,0,0,1,149.12,366c-8.71-8.45-12.1-20.88-13.49-32.75-.19-1.59-.34-3.19-.47-4.78,0-.11-.18-.11-.17,0,.79,12.17,2.68,24.86,10.34,34.65a30.43,30.43,0,0,0,12.47,9.68c6,2.42,12.71,3,19.07,3.85,13.51,1.83,28.18,3.24,41.76,4.3s27.38,1.72,41.09,1.92,27.43,0,41.13-.66c1.67-.08,3.34-.18,5-.33A.08.08,0,0,0,305.85,381.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.34,330c-4.24-.62-8.47-1.23-12.74-1.67s-8.63-.84-12.94-1.2c-8.54-.73-17.1-1.38-25.66-1.78-4.86-.23-9.73-.25-14.59-.19a.12.12,0,0,0,0,.24c8.56.78,17.13,1.31,25.7,1.88s17.1,1.32,25.63,2.14c4.84.46,9.69.82,14.54,1.21C263.63,330.62,263.7,330,263.34,330Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.86,319.31a65.34,65.34,0,0,0-9.83,5.26,78.71,78.71,0,0,0-9.09,6.36c-.08.07,0,.17.1.13,3.34-1.54,6.54-3.47,9.72-5.32a90.76,90.76,0,0,0,9.3-6C207.27,319.61,207.14,319.19,206.86,319.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.86,247.91c28.47,1.69,77.34-9.22,76.42-22.31-.65-9.07-12.23-37.12-30.19-49.54-2.71-1.88-20.24,27.56-16.87,30.72,3.52,3.28,7.25,7.39,8.85,10.73.78,1.62-26.77,11.68-37.78,16.2C168.93,242.06,180.93,247.44,188.86,247.91Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.33,178.56s-18.88-15.32-32.23-18c-5.58-1.12-29.74-.61-29.82,5.23-.07,5.29,20.62,2.49,20.62,2.49s-21.12,1-20,7.37,24,.11,24,.11-21.68,1.49-19.52,7.9c1.63,4.84,22.74.34,22.74.34s-18.62,1.41-17.16,6.46c1.62,5.58,21.36,2.65,21.36,2.65,2.72,9.4,7,13.43,12.81,15.19C222.55,208.71,238.33,178.56,238.33,178.56Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.18,167.46c-2.48,0-5,0-7.47.28s-5,.57-7.39,1a42.44,42.44,0,0,0-9.32,2.75c5.48-1.86,14.32-2.88,16.8-3.13s4.92-.61,7.39-.86A0,0,0,1,0,204.18,167.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.23,176.37c-3.17.17-6.33.23-9.49.53s-6.11.88-9.23,1.41c-.24,0-.14.15.1.12,3.14-.4,6.07-.53,9.21-.89s6.28-.84,9.42-1.09C205.29,176.45,205.28,176.37,205.23,176.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.51,183.87a70.43,70.43,0,0,0-14.45,1.92c-.24.05-.09.18.15.15,4.79-.73,8.55-1.34,14.3-1.9C207.6,184,207.61,183.87,207.51,183.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,250.06,203,227.43S186.79,234,178.62,239.5c-4.58,3.1-3.74,7.07,1.12,8.19C196.77,251.63,216,250.06,216,250.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.79,230.89a167.89,167.89,0,0,0,10.72,18.5s.16,0,.14-.08C208,244.1,202,234.11,200,230.78,200,230.71,199.76,230.82,199.79,230.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.35,323.51l-76.16,4.42c.1-1.56,13.05-58.41,34-84.78,5.6-7.06,17.75-12.29,23.54.18C192.87,256.5,206.39,322.54,205.35,323.51Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.74,299.23a11,11,0,0,0-6.29-.14,16,16,0,0,0-2.52.8,10.55,10.55,0,0,1-.52-8.26,12,12,0,0,1,7-6.92,15,15,0,0,1,2.39-.64c.14,0,.1-.26,0-.25a12.2,12.2,0,0,0-9.29,5.81,11,11,0,0,0-.41,10.65,13.09,13.09,0,0,0-2.28,1.41,10.86,10.86,0,0,0-4,6.33,11.09,11.09,0,0,0-6.72,4,17.1,17.1,0,0,0-3.73,12.57c.06.56.15,1.11.26,1.66l.38,0a18.56,18.56,0,0,1,1.71-10.2c1.56-3.19,4.23-6.21,7.87-6.91h0a10.34,10.34,0,0,0,.14,2.93,8.15,8.15,0,0,0,2.94,5c1.51,1.12,3.61,1.27,4.79-.4a4.81,4.81,0,0,0,.17-4.89,7.23,7.23,0,0,0-4.08-3.36,7.8,7.8,0,0,0-2.92-.44,9.73,9.73,0,0,1,1.92-4,11.79,11.79,0,0,1,3.81-3c1.69,3,4.95,5.62,8.5,5.34a3.66,3.66,0,0,0,3.59-2.72A4.13,4.13,0,0,0,183.74,299.23Zm-8.69,14.13c.28,1.31-.18,3.19-1.69,3.47-1.88.34-3.47-1.78-4.14-3.27a8.64,8.64,0,0,1-.69-4.51C171.3,308.93,174.45,310.5,175.05,313.36Zm8.6-8.06c-3.19.72-6.44-1.75-8.08-4.27-.1-.16-.18-.33-.28-.49a14.08,14.08,0,0,1,4.93-1.07c1.91-.06,4.19.29,5.19,2.14A2.46,2.46,0,0,1,183.65,305.3Zm4.61-58.13a17.07,17.07,0,0,1-6,4.31c-3,1.26-6.72,1.75-9.68,0l0,0a9.75,9.75,0,0,0,1.68-2.13,7.44,7.44,0,0,0,1-5.23c-.37-1.71-1.74-3.09-3.57-2.64a4.46,4.46,0,0,0-3.09,3.31,6.6,6.6,0,0,0,.8,4.81,7.29,7.29,0,0,0,1.76,2.08,8.79,8.79,0,0,1-3.77,1.64,10.82,10.82,0,0,1-4.46-.24,9.79,9.79,0,0,0-1.42-7.62l-.52.72a9.24,9.24,0,0,1,1.19,6.14c0,.18-.07.34-.1.51a13,13,0,0,1-4.06-2.21c-.12.19-.25.38-.36.58a15.14,15.14,0,0,0,2,1.33,12.74,12.74,0,0,0,2.24,1,9.75,9.75,0,0,1-4.66,6.08,10.54,10.54,0,0,1-5,1.28l-.28.56a11.74,11.74,0,0,0,4.05-.5,10.14,10.14,0,0,0,6.75-7.17,12.67,12.67,0,0,0,2.45.41,10.08,10.08,0,0,0,6.6-2,10.21,10.21,0,0,0,7.12,1.28,15.68,15.68,0,0,0,9.6-5.66C188.39,247.57,188.32,247.37,188.26,247.17ZM170,244.06c.6-1.08,2.06-2.11,3.29-1.39,1.52.9,1.33,3.35.9,4.79a8.11,8.11,0,0,1-2.26,3.57C169.88,249.43,168.64,246.42,170,244.06Zm-9.12,41.43c.22-.27.44-.55.63-.83,2.54-3.76,2.3-8.44,1.46-12.71-.25-1.25-.54-2.5-.88-3.73-.05-.21-.35-.11-.31.09.75,4.08,1.75,8.27.64,12.38a11.21,11.21,0,0,1-2,4.06,7.13,7.13,0,0,0-5.82-3.17,4.5,4.5,0,0,0-4.08,2.75,3.14,3.14,0,0,0,1.79,4c2.85,1.28,5.92-.09,8-2.2l.09.15a10.15,10.15,0,0,1-.18,10.17,8.17,8.17,0,0,1-8.36,3.67c-.22-.05-.43-.12-.65-.19a7.92,7.92,0,0,0,.3-5,4.83,4.83,0,0,0-3.23-3.53,2,2,0,0,0-2.21.68,3.67,3.67,0,0,0-.4,2.52,7.64,7.64,0,0,0,2.43,4.61,7.9,7.9,0,0,0,1.72,1.19,5.92,5.92,0,0,1-1.47,1.75,5.06,5.06,0,0,1-4.88.54,12.06,12.06,0,0,1-6-5l-.21.65a13.29,13.29,0,0,0,4.07,4.24,7.27,7.27,0,0,0,5.76,1.31,6,6,0,0,0,3.65-3,8.57,8.57,0,0,0,7.76-1.16A10.3,10.3,0,0,0,162.3,289,11.2,11.2,0,0,0,160.84,285.49Zm-4.32,2.08a5.11,5.11,0,0,1-4.48-.27c-1.58-1.07-1.11-3.07.23-4.11,2.53-2,5.75,0,7.46,2.24A8.39,8.39,0,0,1,156.52,287.57Zm-6,10.64a8.21,8.21,0,0,1-.4,1.34c-2.24-1.19-4.07-3.61-3.75-6.15a1.25,1.25,0,0,1,1.9-1,3.63,3.63,0,0,1,1.63,1.47A6.15,6.15,0,0,1,150.57,298.21Zm53.7,17.1c-1.22,2.31-4.49,2.57-6.94,1.9a8.35,8.35,0,0,1,1.24-3.66,5.13,5.13,0,0,1,3.72-2.52,2.17,2.17,0,0,1,1.25.27c-.06-.31-.13-.63-.19-1a3.65,3.65,0,0,0-1.86,0c-3,.72-4.64,3.68-5,6.62l-.16-.06a10.14,10.14,0,0,1-6-8.18,8.17,8.17,0,0,1,4.38-8c.21-.09.42-.17.64-.24a7.85,7.85,0,0,0,2.79,4.12,5,5,0,0,0,4.33,1c0-.27-.11-.55-.16-.83l-.11,0a3.69,3.69,0,0,1-2.2-.18,6.22,6.22,0,0,1-3.14-3.07,7.86,7.86,0,0,1-.49-1.31,7.3,7.3,0,0,1,5.23,1c-.08-.38-.16-.77-.23-1.16a7.71,7.71,0,0,0-3.14-1,8,8,0,0,0-2.08.1,5.65,5.65,0,0,1,.1-2.28,5,5,0,0,1,3.53-3.4l.2-.06c-.06-.28-.12-.56-.19-.84a6.5,6.5,0,0,0-3.62,2.2,6,6,0,0,0-1,4.64,8.56,8.56,0,0,0-5.45,5.64,10.29,10.29,0,0,0,3.48,10.83,11,11,0,0,0,3.31,1.91c0,.36,0,.7,0,1a11.74,11.74,0,0,0,1.54,5.07l.79-.05a14.37,14.37,0,0,1-.63-1.31,11.33,11.33,0,0,1-.85-4.47,7.1,7.1,0,0,0,6.54-1,5.14,5.14,0,0,0,.66-.66h0C204.4,316.06,204.34,315.69,204.27,315.31Zm-11-47.44a5.68,5.68,0,0,0-2.37-3.06,7.72,7.72,0,0,0-5.57-1.15,7.65,7.65,0,0,1,1.05-4.46,9.54,9.54,0,0,1,4.41-3.82l-.09-.33A9.4,9.4,0,0,0,186,258.4a8.52,8.52,0,0,0-1.57,5.43,11,11,0,0,0-5.64,3.72,6.24,6.24,0,0,0-3-.95,7.69,7.69,0,0,0-6.81,3.6,6.86,6.86,0,0,0-.77,1.78.08.08,0,1,0,.15,0,7,7,0,0,1,5.26-4.81,6.31,6.31,0,0,1,4.8.79,9.79,9.79,0,0,0-1.61,3.35,7.86,7.86,0,0,0,.19,4.75c.45,1.17,1.6,3,3.12,2.54,1.35-.46,2-2.17,2.14-3.45a7.89,7.89,0,0,0-.49-4,7.69,7.69,0,0,0-2.25-3.09,9.64,9.64,0,0,1,5-3.32,8.65,8.65,0,0,0,.62,2.09c1,2.35,3.66,5,6.48,4.28A2.45,2.45,0,0,0,193.26,267.87Zm-13.18,1.56a7,7,0,0,1,1.21,6.57,3.1,3.1,0,0,1-1.1,1.64c-.77.43-1.4-.38-1.78-1a6.07,6.07,0,0,1-.82-3.82,8.84,8.84,0,0,1,1.62-4.31A6.66,6.66,0,0,1,180.08,269.43Zm12.08.53c-.84.77-2.31.42-3.19-.07a6.87,6.87,0,0,1-2.6-2.64,8.19,8.19,0,0,1-1-2.68,7.79,7.79,0,0,1,3.18.15,6,6,0,0,1,2.86,1.63C192.26,267.19,193.22,269,192.16,270Zm-45.71,51.69a8.45,8.45,0,0,0-5.59-.82,11,11,0,0,0-4.45-5.09,6.28,6.28,0,0,0,.53-3.08,7.65,7.65,0,0,0-2.55-5c0,.09-.06.18-.08.26a7.5,7.5,0,0,1,1.73,2.67,6.32,6.32,0,0,1-.13,4.87,10,10,0,0,0-3.41-1.12c-.08.32-.17.63-.26.94a9.25,9.25,0,0,1,3.23,1,6.89,6.89,0,0,1-.75,1,7.31,7.31,0,0,1-3.52,2c-.07.27-.14.53-.2.79a7.92,7.92,0,0,0,5-3.5,9.67,9.67,0,0,1,4,4.48,8.46,8.46,0,0,0-2,.9c-1.84,1.12-3.74,3.4-3.64,5.69l.86-.05a4.21,4.21,0,0,1,.29-1.46,6.89,6.89,0,0,1,2.26-2.94,8.51,8.51,0,0,1,2.52-1.3,7.79,7.79,0,0,1,.29,3.16,6,6,0,0,1-.71,2.27l1-.05a7.82,7.82,0,0,0,.34-5.61,7.73,7.73,0,0,1,4.57.44,9.54,9.54,0,0,1,4.79,4.6h.3A9.66,9.66,0,0,0,146.45,321.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.8,251.07c-4.08,1.78-12.6-3.4-16.45-8.16-.26-.33-.41-4.25-.8-9-.25-2.89-.6-6.1-1.13-9-.11-.59,19,1.11,19,1.11a47.11,47.11,0,0,0,.27,11.46,6.67,6.67,0,0,0,.35,1.17s0,.12.06.19C185.89,241,187.75,249.34,183.8,251.07Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.55,224.78c1.74,4.76,7,16.06,16.71,14.51a12.13,12.13,0,0,0,1.84-.44.8.8,0,0,0-.06-.2,7.52,7.52,0,0,1-.34-1.16,47.27,47.27,0,0,1-.27-11.48S170.64,224.79,166.55,224.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.74,204.78c-.35,6.85,7.61,24.4,13.16,27.37,8,4.3,18.94,2.18,22-7,3-8.87-7.8-31.56-13.79-34C170.31,187.54,158.26,194.66,157.74,204.78Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.55,211.51s-.06.1,0,.15c.62,1.15,1.12,2.56.26,3.47,0,0,0,.08,0,.06C180,214.37,179.32,212.5,178.55,211.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.91,210.81c-1.94.78-.23,4.61,1.57,3.89S178.54,210.16,176.91,210.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.2,208.59c0-.05.12,0,.14.06.49,1.2,1.26,2.5,2.5,2.41,0,0,.07.06,0,.07C186.47,211.53,185.48,209.81,185.2,208.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.71,206.88c1.84-1,3.7,2.76,2,3.68S184.16,207.71,185.71,206.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.46,209a14.07,14.07,0,0,0,1.26-1.18,2.8,2.8,0,0,0,1.05-1.44.9.9,0,0,0-.56-.93,2.2,2.2,0,0,0-2.12.69,3.21,3.21,0,0,0-1.14,2A.94.94,0,0,0,174.46,209Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.64,204.17a15.65,15.65,0,0,1-1.67.41,2.79,2.79,0,0,1-1.78.1.91.91,0,0,1-.47-1,2.18,2.18,0,0,1,1.73-1.4,3.26,3.26,0,0,1,2.32.14A1,1,0,0,1,186.64,204.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.91,223.17c.33.29.67.68,1.14.69a3.32,3.32,0,0,0,1.37-.42s.09,0,.06.06a1.75,1.75,0,0,1-1.59.82,1.4,1.4,0,0,1-1.1-1.08C180.77,223.17,180.86,223.13,180.91,223.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.15,219.31a4.46,4.46,0,0,0,3.5.59,5.84,5.84,0,0,0,1.48-.58,2.26,2.26,0,0,0,.26-.16c.08,0,.16-.09.24-.15a.33.33,0,0,0,.12-.38h0a.47.47,0,0,0-.07-.12h0l-.05-.1c-.38-.93-1.09-2.27-1.09-2.27.41,0,2.45,0,2.21-.44a66.3,66.3,0,0,0-7-11.52c-.08-.12-.27,0-.2.13,1.77,3.77,4.2,7.2,6,10.95a8.05,8.05,0,0,0-2.17.27c-.11.1,1.42,2.59,1.56,3a.12.12,0,0,1,0,.05,6.16,6.16,0,0,1-4.76.57C181.1,219.12,181,219.24,181.15,219.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.12,219.66a4.91,4.91,0,0,1-1.47,2,2.28,2.28,0,0,1-1.27.44c-1,0-1.26-.83-1.3-1.6a5.43,5.43,0,0,1,.1-1.24A6.39,6.39,0,0,0,185.12,219.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.65,221.66a2.28,2.28,0,0,1-1.27.44c-1,0-1.26-.83-1.3-1.6A2.26,2.26,0,0,1,183.65,221.66Z",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.29,219.35c4.94-.87,6-7.29,3.73-11.67,0,0,13.33-1.51,11.36-12a10.49,10.49,0,0,0,9.56,2.55l2.39,3.46c1.23-.71,1.7-4.83-2.28-7,0,0-1.51-5.11-6.1-7.26a7.25,7.25,0,0,0-7.85.84,11,11,0,0,0-8.27,0,9.38,9.38,0,0,0-5.47,6.62s-6.09,2.82-6.05,7.64a9.72,9.72,0,0,0,3.16,7.27s-1.16,2.19.63,5.86C156.24,218.05,158.81,219.62,160.29,219.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.86,194.8a12.6,12.6,0,0,1,.67,2.53,10.49,10.49,0,0,1,.14,2.56,6.73,6.73,0,0,1-2.06,4.47,10.82,10.82,0,0,1-4.46,2.38c-.84.19-1.68.43-2.54.57s-1.72.23-2.59.37c.87,0,1.75-.05,2.63-.07s1.75-.28,2.62-.41a10.85,10.85,0,0,0,4.77-2.4,7.06,7.06,0,0,0,2.1-4.89A10.61,10.61,0,0,0,174.86,194.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,199.13a14,14,0,0,1-4.45-1.13,8.58,8.58,0,0,1-1.9-1.2,10.61,10.61,0,0,1-1.58-1.69,5.79,5.79,0,0,0,1.25,2,6.28,6.28,0,0,0,2,1.42,7.93,7.93,0,0,0,2.33.65A7.31,7.31,0,0,0,183,199.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.05,193.64c.3,1.79-2.4,3.73-6,4.34s-6.82-.36-7.12-2.14,2.4-3.74,6-4.34S167.76,191.85,168.05,193.64Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.55,193.52c.22,1.36-1.83,2.83-4.59,3.29s-5.19-.27-5.41-1.63,1.82-2.83,4.59-3.29S166.32,192.16,166.55,193.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.28,192.15l-1.1-.28c.7-2.81,3.72-3.48,5.22-3.44l0,1.14C170.23,189.57,166.94,189.52,166.28,192.15Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.06,218.87c-.06-.18-1.52-4.32-1.76-5.16s1.37-16.34,1.4-16.43l.54.2.56.09c-.13.87-1.54,14.87-1.39,15.86.22.77,1.71,5,1.73,5.06Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.46,186.06c.3,1.79-2.4,3.73-6,4.33s-6.82-.35-7.11-2.14,2.4-3.73,6-4.33S181.16,184.27,181.46,186.06Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.94,186c.23,1.36-1.82,2.83-4.59,3.29s-5.18-.27-5.41-1.62,1.83-2.84,4.59-3.3S179.72,184.68,179.94,186Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.42,218.79s-5.75-4.8-8-2.59,3.16,9.93,6.63,10.25a3.31,3.31,0,0,0,3.82-2.89Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,218.38c-.05,0,0,.08,0,.08,2.45.3,4.17,2,5.56,3.94a1.82,1.82,0,0,0-2.77.23c-.05.06,0,.13.09.1a2,2,0,0,1,2.35.1,10.07,10.07,0,0,1,1.52,1.47c.16.17.48,0,.35-.24l0,0C165.37,221.19,162.11,217.84,159,218.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.53,244.83c-25.76,26.82-63.33,94.74-68,104.48-3.15,6.61,31.41,24,32.88,19.23,1.88-6.16,32-82.16,40-110.84C170.83,241.88,166.86,239.29,161.53,244.83Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.06,364c-1.2,3.29-5.3,17.28-8.17,19s-17.94,1.37-25.53,1.37-9.08-2.12-9-4.73,16.06-3.11,16.06-3.11-21.28,6.09-26.63,7.09-17.68,4.11-19.47-.33c-.8-2,2.58-4,2.58-4s-5.18,1.51-6-1.06c-.94-2.93,3.17-4.54,3.17-4.54s-3.23.65-3.3-1.73c-.17-5.33,20.07-7.95,20.07-7.95s-15.5,7.54-16,3.19c-.68-6,31.07-12.63,34.37-15.25a22.53,22.53,0,0,0,5.3-6.54Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.51,381a2.34,2.34,0,0,1,.73-2,6.48,6.48,0,0,1,1.85-1.2,24.86,24.86,0,0,1,4.35-1.41c3-.76,6-1.3,9.11-2.09a37.15,37.15,0,0,0-9.38,1.06A17.26,17.26,0,0,0,87.7,377a6.09,6.09,0,0,0-1.87,1.6A2.46,2.46,0,0,0,85.51,381Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.94,379.28c2.18-.53,4.34-1.15,6.5-1.77s4.29-1.28,6.43-1.93l6.41-2q3.21-1,6.43-2a49.93,49.93,0,0,0-6.64,1.19c-2.2.5-4.36,1.13-6.51,1.78s-4.28,1.38-6.38,2.17S60,378.33,57.94,379.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.58,366.28a42.18,42.18,0,0,0-6.14.85,58.21,58.21,0,0,0-11.82,3.71,45.51,45.51,0,0,0-5.51,2.84c2-.67,3.87-1.42,5.81-2.07s3.88-1.32,5.83-1.92,3.92-1.19,5.88-1.77S76.58,366.82,78.58,366.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.45,361.2a38.41,38.41,0,0,0-9.77,2.06,37.94,37.94,0,0,0-9,4.36c3.14-1.12,6.2-2.31,9.33-3.35S72.27,362.22,75.45,361.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.7,270.25l25.88,3.56s4.76-16.8,5.4-26.64c.36-5.52-3.28-7.29-7.16-4.14C148.28,254.06,137.7,270.25,137.7,270.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.81,269.17a167.34,167.34,0,0,0-21.19-2.87s-.06.15,0,.16c5.73,1.11,17.29,2.5,21.17,2.94C162.84,269.41,162.88,269.18,162.81,269.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,273.45c.89,0,1.77.1,2.66.17l-.22.14.91-3.86,1-3.84c.66-2.56,1.33-5.11,2-7.67a54.63,54.63,0,0,1-1.33,7.84,78.37,78.37,0,0,1-2.21,7.64l-.06.17-.16,0C162.68,273.84,161.81,273.66,161,273.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,264.76a8.06,8.06,0,0,1,.7-1.91,10.23,10.23,0,0,1,1.05-1.73,3.88,3.88,0,0,1-.22,1,6.91,6.91,0,0,1-.39.94A6.7,6.7,0,0,1,166,264.76Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Basket--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.05,350.12s7,36.21,9.48,44,5.52,10.06,14.55,10.06H323c5.47,0,8.07-5.72,10.56-15.14s8.79-38.69,8.79-38.69Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.05,350.12s7,36.21,9.48,44,5.52,10.06,14.55,10.06H323c5.47,0,8.07-5.72,10.56-15.14s8.79-38.69,8.79-38.69Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M284.16,398.21c-2.81-.16-5.63-.2-8.45-.24h-1.82a.92.92,0,0,0,0-.16c0-.24,0-.47,0-.71,0-.49,0-1,0-1.46s0-1-.08-1.47a4,4,0,0,0-.06-.47h.89l3.18,0a26.94,26.94,0,0,0,3.11-.11c.17,0,.11-.26,0-.28a24.2,24.2,0,0,0-2.82-.13l-2.82-.06-5.57,0h-2.61a.61.61,0,0,1-.05-.12,3.6,3.6,0,0,0,.1-1c0-.41,0-.82,0-1.23a22.41,22.41,0,0,0-.16-2.32h1.15c2.47,0,4.94,0,7.41,0,1.39,0,2.78,0,4.16-.13.11,0,.11-.16,0-.16-4.93-.3-9.88-.26-14.81-.21-1.39,0-2.78.08-4.17.17,0,0-.06.09,0,.09,2,.15,4,.21,6,.24,0,.07,0,.15,0,.22a0,0,0,0,1,0,0,0,0,0,0,0,0,0q-.1,1.15-.15,2.31c0,.44,0,.89-.05,1.33a3.53,3.53,0,0,0,0,.65l.06.13c-2.67,0-5.33,0-8,0-2.08,0-4.16.14-6.24.09-.08,0-.08.1,0,.11a51.5,51.5,0,0,0,5.56.29h1a1.66,1.66,0,0,0,0,.22c0,.22,0,.44-.06.65,0,.42,0,.84,0,1.26s0,.83,0,1.25c0,.22,0,.43,0,.65a1.22,1.22,0,0,0,0,.26q-4.24,0-8.48,0l-4,.08a3.11,3.11,0,0,0,0-.79c0-.39,0-.77,0-1.15,0-.76-.14-1.51-.23-2.26,0,0-.07,0-.07,0,0,.76-.06,1.52-.1,2.28l-.06,1.11a3.11,3.11,0,0,0,0,.81h-.34c-1.6,0-3.19.12-4.79.16a0,0,0,0,0,0,.09c1.43,0,2.86.09,4.29.12l4.16.07c2.82.05,5.64.06,8.45.08l16.91.09c3.19,0,6.38.07,9.56,0A.19.19,0,0,0,284.16,398.21Zm-16.9-.32-7.92,0a1,1,0,0,0,0-.25c0-.21,0-.43,0-.65,0-.42-.05-.83-.07-1.25s0-.84-.07-1.26c0-.22,0-.44-.05-.65s0-.15,0-.22l4.42.06q5,0,9.93.05c0,.12,0,.23,0,.26,0,.2,0,.4,0,.61,0,.45,0,.9,0,1.36s0,.87,0,1.31c0,.21,0,.47,0,.72Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M325.76,385.05c-1.64-.07-3.28-.06-4.92,0a1.75,1.75,0,0,0,0-.71c0-.39,0-.78-.06-1.17s-.07-.78-.13-1.16a4.85,4.85,0,0,0-.09-.55.83.83,0,0,0-.1-.38c.47,0,.95,0,1.42-.05.09,0,.08-.12,0-.13-2.86-.21-5.74-.32-8.6-.34s-5.68-.07-8.52,0c-1.61,0-3.23,0-4.83.13-.06,0-.07.1,0,.11,1.39.16,2.8.17,4.19.22,1,0,2,.06,3,.08,0,0,0,0,0,0,0,.7,0,1.4,0,2.1s0,1.4,0,2.09h0c-.72,0-1.44.07-2.16.08,0,0,0,.07,0,.07,1.35,0,2.69.16,4,.18l4,0h.74a1.19,1.19,0,0,0,0,.33c0,.17,0,.35,0,.53,0,.36,0,.73,0,1.09s0,.7.07,1.06c0,.17,0,.35.05.52l0,.18-2.26,0c-.85,0-1.69.09-2.54.12,0,0,0,.08,0,.08.86.06,1.7.14,2.56.16h2.48a38.21,38.21,0,0,0,5-.29.09.09,0,0,0,0-.18c-1.62-.07-3.24,0-4.86.06a.89.89,0,0,0,0-.23c0-.17,0-.35,0-.53,0-.35-.05-.7-.09-1.05s-.08-.7-.13-1.05c0-.16,0-.32-.07-.48a1.36,1.36,0,0,0-.09-.36c2.42,0,4.85,0,7.27-.11,1.53-.05,3.05-.1,4.58-.24A.11.11,0,0,0,325.76,385.05Zm-5.39-3.54v.55c0,.39,0,.78,0,1.17s0,.78,0,1.17a1.49,1.49,0,0,0,.07.61l-2.82,0c-2.71,0-5.42.08-8.13.12-.66,0-1.32,0-2,.06h0a14.72,14.72,0,0,0,0-2.1c0-.69-.11-1.39-.22-2.08h0l1.13,0c2.85.06,5.72.14,8.58.08l3.38-.09A.94.94,0,0,0,320.37,381.51Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M342.34,350.39s-1,4.9-2.46,11.34l-116.4-4.36c-.87-4.35-1.43-7.26-1.43-7.26Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.3,342.44c-2.36.17-2.18,10.67,0,11,1.11.19,126.94.77,127.84.45,1.81-.65,2.53-9.33.39-10.29C345.4,343.16,219.43,342.36,218.3,342.44Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.3,342.44c-2.36.17-2.18,10.67,0,11,1.11.19,126.94.77,127.84.45,1.81-.65,2.53-9.33.39-10.29C345.4,343.16,219.43,342.36,218.3,342.44Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.7,
    y: 361.41,
    width: 58.84,
    height: 8.95,
    transform: "translate(-184.45 246.66) rotate(-41.64)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.7,
    y: 361.41,
    width: 58.84,
    height: 8.95,
    transform: "translate(-184.45 246.66) rotate(-41.64)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.03,
    y: 361.41,
    width: 58.84,
    height: 8.95,
    transform: "matrix(-0.75, -0.66, 0.66, -0.75, 344.82, 862.88)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.03,
    y: 361.41,
    width: 58.84,
    height: 8.95,
    transform: "matrix(-0.75, -0.66, 0.66, -0.75, 344.82, 862.88)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.04 342.53 322.35 343.2 282.19 367.82 242.04 342.53",
    style: {
      fill: "#FFC727"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Drink--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.17,371.41V400c0,.88-.83,3.78-2.35,3.78H190c-1.51,0-2.34-2.9-2.34-3.78V371.41c0-1.55,2.34-4.42,2.34-4.42h19.87s1.17,2,2.06,3.61A1.77,1.77,0,0,1,212.17,371.41Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.95,
    y: 403.76,
    width: 19.87,
    height: 2.56,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.95,
    y: 364.44,
    width: 19.87,
    height: 2.56,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.17,376V396.8c-7.54,1.26-17.56.89-24.56-4v-3.95S200.91,390.55,212.17,376Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.17,371.41v3.75c-5.9,5-15.36,11.32-24.56,10.2v-.66s13.1-1.23,24.27-14.1A1.77,1.77,0,0,1,212.17,371.41Z",
    style: {
      fill: "#fff"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAfternoon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/afternoon.f7d04b1a24fd6c05c5d18522a5da0f64.svg";